<template>
  <CommonPages id="about" class="about common-text" headerTheme="dark" titlePrefix="About Us">
    <div class="common-text__container">
      <div class="common-text__content ">
        <h1 class="common-text__title">About Us</h1>

        <div class="common-text__section">
          <p class="common-text__paragraph">
            Welcome to {{ domainConfig?.IAmURL }}!
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">Our Mission</h2>
          <p class="common-text__paragraph">
            At {{ domainConfig?.IAmURL }}, our mission is to provide reliable and insightful content on automotive vehicles. We strive to offer valuable resources and information to our audience.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">Our Team</h2>
          <p class="common-text__paragraph">
            Our team consists of experienced professionals passionate about automotive industry. We are committed to delivering high-quality content that is both informative and engaging.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">What We Offer</h2>
          <p class="common-text__paragraph">
            <strong>Original Content:</strong> Our articles and resources are thoroughly researched and crafted to ensure accuracy and relevance.
            <br><br>
            <strong>Expert Insights:</strong> We collaborate with industry experts to bring you the latest trends and insights.
            <br><br>
            <strong>Community Engagement:</strong> We value our community and encourage feedback and interaction.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">Our Values</h2>
          <p class="common-text__paragraph">
            <strong>Integrity:</strong> We maintain high ethical standards and transparency in all our content.
            <br><br>
            <strong>Innovation:</strong> We continually seek new ways to improve and expand our offerings.
            <br><br>
            <strong>Inclusivity:</strong> We aim to create an inclusive environment where diverse perspectives are valued.
          </p>
        </div>

        <div class="common-text__section">
          <h2 class="common-text__section-title">Contact Us</h2>
          <p class="common-text__paragraph">
            We love hearing from our readers! If you have any questions, suggestions, or feedback, feel free to reach out to us at {{ domainConfig?.IAMEMAIL }}.
            <br><br>
            Thank you for visiting {{ domainConfig?.IAmURL }}. We hope you find our content helpful and inspiring!
          </p>
        </div>

      </div>
    </div>
    <div class="common-text__container">
      <div class="about-car-list"></div>
    </div>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'About',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'domainConfig'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.common-text {
	background: #000;
	min-height: 100vh;

	.about-car-list {
		background: url('../assets/about-bg-pc.png') no-repeat center center;
		background-size: 100% 100%;
		width: 100%;
		height: rem(300);
	}

	&__content {
		margin: 0 auto;
		padding: rem(40) rem(180);
		width: 100%;
	}

	&__title {
		color: #fff;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(24);
		margin-bottom: rem(24);
	}

	&__section {
		margin-bottom: rem(40);
	}

	&__section-title {
		color: #fff;

		font-size: rem(24);
		font-weight: 700;
		line-height: rem(28);
		margin-bottom: rem(16);
	}

	&__subsection-title {
		color: #fff;

		font-size: rem(18);
		font-weight: 600;
		line-height: rem(24);
		margin-top: rem(20);
		margin-bottom: rem(12);
	}

	&__paragraph {
		color: rgba(255, 255, 255, 0.6);

		font-size: rem(12);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
	}

	&__link {
		color: var(--theme-color);
		text-decoration: underline;
		text-decoration-thickness: auto;
		text-decoration-style: solid;
		text-decoration-skip-ink: none;

		&:hover {
			opacity: 0.8;
		}
	}

	&__list,
	&__numbered-list {
		color: #777;

		font-size: rem(14);
		font-weight: 400;
		line-height: rem(24);
		margin-bottom: rem(16);
		padding-left: rem(20);
	}

	&__list {
		list-style-type: disc;
	}

	&__numbered-list {
		list-style-type: decimal;
	}

	&__list-item,
	&__numbered-list-item {
		margin-bottom: rem(8);

		&:last-child {
			margin-bottom: 0;
		}
	}

	&__table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: rem(20);

		font-size: rem(14);

		th,
		td {
			border: 1px solid #e9e9e9;
			padding: rem(10) rem(16);
			text-align: left;
		}

		th {
			background-color: #f5f7fa;
			color: #141414;
			font-weight: 600;
		}

		td {
			color: #777;
		}
	}

	&__blockquote {
		border-left: 4px solid #405ff2;
		padding: rem(16) rem(20);
		background-color: #f5f7fa;
		margin: rem(16) 0;
		color: #777;

		font-size: rem(14);
		font-style: italic;
		line-height: rem(24);
	}

	&__code-block {
		background-color: #f5f7fa;
		border-radius: rem(8);
		padding: rem(16);
		margin: rem(16) 0;
		overflow-x: auto;

		pre {
			margin: 0;

			code {
				color: #777;
				font-size: rem(14);
				line-height: 1.5;
			}
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.common-text {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);

		&__title {
			font-size: rem(24);
			line-height: rem(24);
		}

		&__section-title {
			font-size: rem(16);
			line-height: rem(24);
		}
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.about-car-list {
		display: flex;
		flex-wrap: wrap;
		row-gap: rem(16);
		column-gap: rem(1);
		margin-top: rem(1);
    background: url('../assets/about-bg-mobile.png') no-repeat center center;
		background-size: 100% 100%;
		width: 100%;
		height: rem(520);
		.about-car-item {
			flex: 0 0 calc((100% - rem(1)) / 2); /* 使每个子元素占1/3的宽度 */
		}

	}

	.common-text {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);

		&__content {
			padding: 0 rem(16);
		}

		&__content {
			max-width: rem(343);
			padding: rem(20);
		}

		&__title {
			font-size: rem(24);
			line-height: rem(24);
			margin-bottom: rem(20);
		}

		&__section-title {
			font-size: rem(16);
			font-style: normal;
			font-weight: 900;
			line-height: rem(24); /* 150% */
			margin-bottom: rem(8);
		}

		&__subsection-title {
			color: #141414;

			font-size: rem(12);
			font-weight: 600;
			line-height: rem(24);
			margin-top: rem(16);
			margin-bottom: rem(8);
		}

		&__paragraph {
			color: #777;

			font-size: rem(12);
			font-weight: 400;
			line-height: rem(24);
			margin-bottom: rem(8);
		}

		&__list,
		&__numbered-list {
			font-size: rem(12);
			line-height: rem(24);
			margin-bottom: rem(12);
		}

		&__list-item,
		&__numbered-list-item {
			margin-bottom: rem(6);
		}

		&__blockquote {
			font-size: rem(12);
			padding: rem(12) rem(16);
			margin: rem(12) 0;
		}

		&__table {
			font-size: rem(12);

			th,
			td {
				padding: rem(8) rem(12);
			}
		}
	}
}
</style>